import { render, staticRenderFns } from "./listiklan.vue?vue&type=template&id=1add7764&"
import script from "./listiklan.vue?vue&type=script&lang=js&"
export * from "./listiklan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports